module.exports = __webpack_public_path__ + "static/img/Image_004.3b57942.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/Image_004.png
// module id = 4YJx
// module chunks = 3